// extracted by mini-css-extract-plugin
export var address = "style-module--address--rRmkc";
export var contacts = "style-module--contacts--ifMMS";
export var contactsContainer = "style-module--contactsContainer--+otOY";
export var copy = "style-module--copy--2zg08";
export var fixed = "style-module--fixed--jTfLR";
export var footerContainer = "style-module--footerContainer--7AJi9";
export var footerContainerLogo = "style-module--footerContainerLogo--5OMcP";
export var footerHeader = "style-module--footerHeader--z5FVR";
export var gaifulLogo = "style-module--gaifulLogo--roFAH";
export var info = "style-module--info--dGK17";
export var infoBlock = "style-module--infoBlock--7DsVY";
export var infoContainer = "style-module--infoContainer--v7ZuK";
export var privacyContainer = "style-module--privacyContainer--uiuIc";
export var privacyContainerLinks = "style-module--privacyContainerLinks--fF+Zv";
export var warningDesktop = "style-module--warningDesktop--p4TGR";
export var warningMobile = "style-module--warningMobile--8wjUH";